import React, { useState } from 'react';
import { Select } from 'antd';
import XsjReport from './XsjReport';
import { CustomProjectProps } from './types';

const { Option } = Select;

const CustomProject: React.FC<CustomProjectProps> = ({ username, displayName, isLoggedIn }) => {
  const [selectedProject, setSelectedProject] = useState<string>('xsj_report');

  return (
    <div>
      {/* 项目选择器 */}
      <div style={{ marginBottom: '24px' }}>
        <Select
          value={selectedProject}
          onChange={setSelectedProject}
          style={{ width: '300px' }}
          size="large"
        >
          <Option value="xsj_report">西山居报告传输</Option>
        </Select>
      </div>

      {/* 根据选择渲染不同的项目页面 */}
      {selectedProject === 'xsj_report' && (
        <XsjReport username={username} displayName={displayName} isLoggedIn={isLoggedIn} />
      )}
    </div>
  );
};

export default CustomProject;

